import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppShell from "@/components/layout/AppShell";
import Login from "@/pages/Login";
import Setup from "@/pages/Setup";
import RecuperoPassword from "@/pages/RecuperoPassword";
import AttivaAccount from "@/pages/AttivaAccount";
import Registrati from "@/pages/Registrati";
import Dashboard from "@/pages/Dashboard";
import RequestsPage from "@/pages/Requests";
import Malattie from "@/pages/Malattie";
import Comunicazioni from "@/pages/Comunicazioni";
import ComunicazioneDetail from "@/pages/ComunicazioneDetail";
import Sondaggi from "@/pages/Sondaggi";
import SondaggioDetail from "@/pages/SondaggioDetail";
import Notifiche from "@/pages/Notifiche";
import Incontri from "@/pages/Incontri";
import Calendario from "@/pages/Calendario";
import Rete from "@/pages/Rete";
import NetworkSoci from "@/pages/NetworkSoci";
import { can } from "@/lib/perm";
import Dipendenti from "@/pages/Dipendenti";
import Personalizzazione from "@/pages/Personalizzazione";
import Registro from "@/pages/Registro";
import Profilo from "@/pages/Profilo";
import { Loader2 } from "lucide-react";

function Protected({ admin, perm, children }) {
  const { user } = useAuth();
  if (user === undefined)
    return (
      <div className="flex h-screen items-center justify-center" data-testid="app-loading">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  if (perm && !can(user, perm)) return <Navigate to="/" replace />;
  return children;
}

const A = (el) => <Protected admin>{el}</Protected>;

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/accesso/:code" element={<Login />} />
            <Route path="/setup" element={<Setup />} />
            <Route path="/recupero-password" element={<RecuperoPassword />} />
            <Route path="/attiva-account" element={<AttivaAccount />} />
            <Route path="/registrati" element={<Registrati />} />
            <Route element={<Protected><AppShell /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="ferie" element={<RequestsPage key="leaves" kind="leaves" />} />
              <Route path="permessi" element={<RequestsPage key="permissions" kind="permissions" />} />
              <Route path="malattie" element={<Malattie />} />
              <Route path="comunicazioni" element={<Comunicazioni />} />
              <Route path="comunicazioni/:id" element={<ComunicazioneDetail />} />
              <Route path="sondaggi" element={<Sondaggi />} />
              <Route path="sondaggi/:id" element={<SondaggioDetail />} />
              <Route path="notifiche" element={<Notifiche />} />
              <Route path="incontri" element={<Incontri />} />
              <Route path="profilo" element={<Profilo />} />
              <Route path="rete" element={A(<Rete />)} />
              <Route path="calendario" element={<Protected perm="view_calendar"><Calendario /></Protected>} />
              <Route path="network-soci" element={A(<NetworkSoci />)} />
              <Route path="dipendenti" element={A(<Dipendenti />)} />
              <Route path="personalizzazione" element={A(<Personalizzazione />)} />
              <Route path="registro" element={A(<Registro />)} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
